var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#0B93E3",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2995 43.231L60.082 56.0135",
    stroke: "#0B93E3",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1394 47.3933L55.9219 60.1758",
    stroke: "#0B93E3",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9198 60.1758C56.4717 60.7277 57.2203 61.0378 58.0009 61.0378C58.7815 61.0378 59.5301 60.7277 60.082 60.1758",
    stroke: "#0B93E3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0833 56.0135C60.6352 56.5655 60.9453 57.3141 60.9453 58.0947C60.9453 58.8752 60.6352 59.6238 60.0833 60.1758",
    stroke: "#0B93E3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8789 32.2158C18.8789 33.9551 19.2214 35.6773 19.887 37.2842C20.5526 38.891 21.5281 40.351 22.758 41.5809C23.9878 42.8107 25.4478 43.7863 27.0547 44.4519C28.6616 45.1174 30.3838 45.46 32.123 45.46C33.8623 45.46 35.5845 45.1174 37.1913 44.4519C38.7982 43.7863 40.2582 42.8107 41.4881 41.5809C42.7179 40.351 43.6935 38.891 44.359 37.2842C45.0246 35.6773 45.3672 33.9551 45.3672 32.2158C45.3672 28.7033 43.9718 25.3346 41.4881 22.8508C39.0043 20.367 35.6356 18.9717 32.123 18.9717C30.3838 18.9717 28.6616 19.3143 27.0547 19.9798C25.4478 20.6454 23.9878 21.621 22.758 22.8508C21.5281 24.0806 20.5526 25.5407 19.887 27.1475C19.2214 28.7544 18.8789 30.4766 18.8789 32.2158Z",
    stroke: "#0B93E3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3008 43.231L43.1385 47.3932",
    stroke: "#0B93E3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2188 45.3122L41.4875 41.5809",
    stroke: "#0B93E3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8516 46.7837L46.6893 50.9459",
    stroke: "#0B93E3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7671 32.2158C24.7671 34.1672 25.5423 36.0388 26.9222 37.4186C28.3021 38.7985 30.1736 39.5737 32.125 39.5737",
    stroke: "#0B93E3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.2d3bb20baabeac5f4a77e96589af91f0.svg";
export { ForwardRef as ReactComponent };